import type { EdgeDescriptor } from '@bliks-io/ui';
import { resolvePosition } from './shared';
import { insertBetweenStartAndStep } from './insertBetween/startAndStep';
import { insertBetweenStepAndEnd } from './insertBetween/stepAndEnd';
import { insertBetweenStepAndStep } from './insertBetween/stepAndStep';
import { insertBetweenTaskForkBeforeGateway } from './insertBetween/taskForkBeforeGateway';
import type { EdgeActionDeps } from './types';

export async function performInsertBetween(
  edge: EdgeDescriptor,
  deps: EdgeActionDeps
): Promise<void> {
  const { source, target } = edge;
  const position = resolvePosition(edge, deps);

  if (source.kind === 'start' && target.kind === 'step' && target.stepId) {
    // The legacy synthesized `start-node` (no eventId) can no longer appear
    // in the draft editor; without a real start event there is nothing to
    // re-wire, so it's a no-op.
    if (source.eventId) {
      await insertBetweenStartAndStep(source.eventId, target.stepId, position, deps);
    }
    return;
  }
  if (edge.taskForkRole === 'beforeFork' && source.stepId) {
    await insertBetweenTaskForkBeforeGateway(source.stepId, position, deps);
    return;
  }
  if (target.kind === 'end' && source.kind === 'step' && source.stepId) {
    await insertBetweenStepAndEnd(source.stepId, edge.ruleId, position, deps);
    return;
  }
  if (source.stepId && target.stepId && source.stepId !== target.stepId) {
    await insertBetweenStepAndStep(
      {
        sourceStepId: source.stepId,
        targetStepId: target.stepId,
        ruleId: edge.ruleId,
        position
      },
      deps
    );
  }
}
